'use es6';

import { fromJS as fromJSUnsafe } from 'immutable';
export const has = (obj = {}, key) => obj.toJS ? obj.has(key) : Object.prototype.hasOwnProperty.call(obj, key);
export const get = (obj = {}, key, fallback) => obj.toJS ? obj.get(key, fallback) : obj[key] || fallback;
export const hasIn = (obj = {}, path = []) => {
  let curr = obj;
  return path.every(key => {
    curr = get(curr, key);
    return curr !== undefined;
  });
};
export const getIn = (obj = {}, path = [], fallback) => {
  let curr = obj;
  path.every(key => {
    if (has(curr, key)) {
      curr = get(curr, key);
      return true;
    } else {
      curr = fallback;
      return false;
    }
  });
  return curr;
};
export const reduce = (obj = [], apply, initial) => {
  return obj.toJS || Array.isArray(obj) ? obj.reduce(apply, initial) : Object.keys(obj).reduce((reduction, key) => {
    const value = get(obj, key);
    return apply(reduction, value, key);
  }, initial);
};
export const toJS = (obj = {}) => obj.toJS ? obj.toJS() : obj;
export const fromJS = (obj = {}) => obj.toJS ? obj : fromJSUnsafe(obj);
export const isObject = obj => typeof obj === 'object';
export const isEmpty = obj => {
  if (obj == null) return true;
  if (obj.isEmpty) return obj.isEmpty();
  if (obj.length > 0) return false;
  if (obj.length === 0) return true;
  if (!isObject(obj)) return true;
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
  }
  return true;
};